import { render } from "./OJTInstructorDataTable.vue?vue&type=template&id=790c8a64&scoped=true"
import script from "./OJTInstructorDataTable.vue?vue&type=script&lang=js"
export * from "./OJTInstructorDataTable.vue?vue&type=script&lang=js"

import "./OJTInstructorDataTable.vue?vue&type=style&index=0&id=790c8a64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790c8a64"]])

export default __exports__